"use client";

import { useRouter } from "next/navigation";
import { Button, Grid } from "@mui/material";

export default function LoginButton() {
  const router = useRouter();

  return (
    <Grid container>
      <Grid
        size={{
          xs: 12,
          sm: 12,
        }}
        sx={{
          display: "flex",
          justifyContent: "center",
          mt: { xs: 4, sm: 0 },
        }}
      >
        <Button
          key="login-page-button"
          onClick={() => router.push("https://www.morainepark.edu/login")}
          color="primary"
          sx={{
            height: 48,
            paddingLeft: "2em",
            paddingRight: "2em",
            width: {
              xs: "100%",
              sm: "auto",
            },
          }}
          variant="contained"
        >
          Login Page
        </Button>
      </Grid>
    </Grid>
  );
}
